import { cn } from "lib/utils";
import styles from "./quiz-option.module.css";
import Check from "./check.svg";

interface QuizOptionProps {
  icon: string;
  title: string;
  isSelected?: boolean;
  onClick: () => void;
}

export function QuizOption({
  icon,
  title,
  isSelected,
  onClick,
}: QuizOptionProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        styles.button,
        !icon && !isSelected && styles.buttonNoIcon,
        isSelected && styles.buttonSelected,
      )}
    >
      <div className={styles.flexCol}>
        <div className={styles.flexItems}>
          {icon ? (
            <div
              className={cn(
                styles.iconWrapper,
                isSelected
                  ? styles.iconWrapperSelected
                  : styles.iconWrapperNotSelected,
              )}
            >
              {icon}
            </div>
          ) : (
            isSelected && (
              <div
                className={cn(styles.iconWrapper, styles.iconWrapperSelected)}
              >
                <img src={Check} alt="Check" />
              </div>
            )
          )}
          <div
            className={cn(
              styles.textLeft,
              isSelected ? styles.textSelected : styles.textNotSelected,
            )}
          >
            {title}
          </div>
        </div>
      </div>
    </button>
  );
}
